import React from 'react';

const NextArrow = props => {
  const { className, onClick, addClass } = props;
  return <div className={`${className} ${addClass}`} onClick={onClick} />;
};

export default NextArrow;
